

var _base = require('./base64');

var _validators = require('./validators');

var _logger = require('xo-beaver/dist/logger');

var _customUtil = require('../../js/lib/customUtil.js');

var _ = require('underscore');
// TODO: add a constants file and move all the constants to that file

module.exports = {

    getButtonParams: function getButtonParams(urlParams) {
        if (!urlParams) {
            return;
        }
        var jsonParams = _customUtil.customUtil.decodeAndParse(urlParams);
        var buttonItem = void 0,
            viewCart = void 0;
        if (isAddToCart(jsonParams)) {
            buttonItem = mapAddToCartParams(jsonParams);
            viewCart = false;
        } else {
            viewCart = true;
        }
        var buttonParams = {};
        buttonParams.buttonItem = buttonItem;
        buttonParams.visitorId = jsonParams['visitor_id'];
        buttonParams.payeeEmail = jsonParams['merchant_email'];
        buttonParams.viewCart = viewCart;
        buttonParams.merchantId = jsonParams['merchant_id'];
        return buttonParams;
    },

    validateAndGetAdditionalCharges: function validateAndGetAdditionalCharges(shoppingCart) {
        var items = shoppingCart && shoppingCart.items;
        if (!items || items.length === 0) {
            return;
        }
        var additionalCharges = void 0,
            shipping = void 0,
            tax = void 0,
            handlingCost = void 0,
            discount = void 0;

        if (items === undefined || items.length === 0) {
            return additionalCharges;
        }
        _.forEach(items, function (item) {
            shipping = sumCharge(shipping, item.shipping_cost);
            if (!item.tax_rate && item.tax) {
                tax = sumCharge(tax, (item.tax * item.quantity).toFixed(2));
            } else if (item.tax) {
                tax = sumCharge(tax, item.tax);
            }
            handlingCost = sumCharge(handlingCost, item.handling_cost);
            discount = sumCharge(discount, item.discount);
        });
        if (shoppingCart.total_handling_charges) {
            handlingCost = +shoppingCart.total_handling_charges.value || handlingCost;
        }
        additionalCharges = addCharge(additionalCharges, 'shipping', shipping);
        var formattedTax = formatValue(tax, 2);
        if (formattedTax) {
            formattedTax = Number(formattedTax);
            additionalCharges = addCharge(additionalCharges, 'tax', formattedTax);
        }
        additionalCharges = addCharge(additionalCharges, 'handling', handlingCost);
        if (discount) {
            if (discount < addItemAmounts(shoppingCart.items)) {
                var formattedDiscount = formatValue(discount, 2);
                if (formattedDiscount) {
                    additionalCharges = addCharge(additionalCharges, 'discount', Number(formattedDiscount));
                }
            } else {
                _logger.$logger.info('discount_exceeds_itemTotal');
            }
        }
        // total shipping and total handlingCost must be positive
        return {
            cartValid: (shipping === undefined || shipping >= 0) && (handlingCost === undefined || handlingCost >= 0),
            charges: additionalCharges
        };
    },

    addItemToCart: function addItemToCart(buttonItem, shoppingCart) {
        if (!buttonItem || !buttonItem.items || !buttonItem.items.length === 0) {
            return shoppingCart;
        }
        if (!shoppingCart) {
            return buttonItem;
        }
        if (!shoppingCart.items || shoppingCart.items.length === 0) {
            shoppingCart.items = [buttonItem.items[0]];
            return shoppingCart;
        }
        var index = isItemPresentInList(buttonItem.items[0], shoppingCart.items);
        _logger.$logger.info('isItemPresentInList', { index: index });
        if (index > -1) {
            shoppingCart.items[index].quantity = parseInt(shoppingCart.items[index].quantity, 10) + parseInt(buttonItem.items[0].quantity, 10);
            if (buttonItem.items[0].tax_rate) {
                shoppingCart.items[index].tax_rate = buttonItem.items[0].tax_rate;
            } else if (buttonItem.items[0].tax) {
                shoppingCart.items[index].tax = buttonItem.items[0].tax;
            }
        } else {
            shoppingCart.items.push(buttonItem.items[0]);
            if (buttonItem.total_handling_charges && !shoppingCart.total_handling_charges) {
                shoppingCart['total_handling_charges'] = buttonItem.total_handling_charges;
            }
            if (buttonItem.total_weight && !shoppingCart.total_weight) {
                shoppingCart['total_weight'] = buttonItem.total_weight;
            }
        }
        shoppingCart = updateParamsFromButtonItem(shoppingCart, buttonItem);
        return shoppingCart;
    },

    getMerchantDetails: function getMerchantDetails(shoppingCart, buttonItemDetails) {
        if (!shoppingCart) {
            return {};
        }
        var merchantDetails = {
            imageUrl: shoppingCart && shoppingCart.urls && shoppingCart.urls.image_url,
            brand_name: shoppingCart && shoppingCart.payee && shoppingCart.payee.business_name,
            merchant_email: buttonItemDetails && buttonItemDetails.payee && buttonItemDetails.payee.email
        };
        return merchantDetails;
    },

    getItemsForCheckout: function getItemsForCheckout(itemList) {
        var updatedList = [];
        if (itemList && itemList.length !== 0) {
            _.forEach(itemList, function (item) {
                if (item.quantity !== '0') {
                    updatedList.push(item);
                }
            });
        }
        return updatedList;
    },

    removeHashKey: function removeHashKey(shoppingCart) {
        _.forEach(shoppingCart.items, function (item) {
            if (item.item_option_selections) {
                _.forEach(item.item_option_selections, function (option, index) {
                    if (option.$$hashKey) {
                        delete option.$$hashKey;
                    }
                });
            }
        });
    },

    getParamsForCheckout: function getParamsForCheckout(xclickParams) {
        var decodedParams = (0, _base.base64Decode)(xclickParams);
        var urlParams = decodeURIComponent(decodedParams);
        var paramsList = urlParams.split('&');
        var usedParams = void 0;
        var unUsedParams = ['visitor_id', 'merchant_email', 'business_name', 'merchant_id', 'cmd'];
        _.forEach(paramsList, function (param) {
            var key = param.split('=')[0];
            if (key && unUsedParams.indexOf(key) === -1) {
                if (key === 'add') {
                    param = 'display=1';
                }
                usedParams = usedParams ? usedParams + '&' + param : param;
            }
        });
        var encodedUrlParams = encodeURIComponent(usedParams);
        var encodedParams = (0, _base.base64Encode)(encodedUrlParams);
        return encodedParams;
    },

    getCartItemsTotal: function getCartItemsTotal(itemsInCart) {
        return addItemAmounts(itemsInCart);
    }
};

var updateParamsFromButtonItem = function updateParamsFromButtonItem(shoppingCart, buttonItem) {
    var cartParams = ['urls', 'total_handling_charges', 'address_override'];
    for (var key in cartParams) {
        if (cartParams.hasOwnProperty(key) && buttonItem[cartParams[key]]) {
            shoppingCart[cartParams[key]] = buttonItem[cartParams[key]];
        }
    }
    // cannot override the button_source
    var customizedParams = ['custom', 'note_to_seller_label', 'locale_code', 'return_url_label', 'return_method', 'mrb_code'];
    if (buttonItem.items[0].customized_info) {
        _.forEach(shoppingCart.items, function (item, index) {
            if (!item.customized_info) {
                shoppingCart.items[index].customized_info = {};
            }
            for (var i = 0; i < customizedParams.length; i += 1) {
                var _key = customizedParams[i];
                shoppingCart.items[index].customized_info[_key] = buttonItem.items[0].customized_info[_key];
            }
        });
    }
    return shoppingCart;
};

var sumCharge = function sumCharge(sum, value) {
    if (value !== undefined) {
        if (sum === undefined) {
            sum = 0;
        }
        sum = Number(sum) + Number(value);
    }
    return sum;
};

var addCharge = function addCharge(additionalCharges, name, value) {
    if (value !== undefined) {
        if (additionalCharges === undefined) {
            additionalCharges = [];
        }
        additionalCharges.push({ name: name, value: value });
    }
    return additionalCharges;
};

var isAddToCart = function isAddToCart(jsonParams) {
    var addToCart = false;
    if (jsonParams['add'] === '1') {
        addToCart = true;
    }
    return addToCart;
};

var mapAddToCartParams = function mapAddToCartParams(jsonParams) {
    var buttonParams = {};
    buttonParams = mapCartParams(buttonParams, jsonParams);
    buttonParams = mapCartAmounts(buttonParams, jsonParams);
    buttonParams = mapItemParams(buttonParams, jsonParams);
    buttonParams = mapDiscountParams(buttonParams, jsonParams);
    buttonParams = mapShippingParams(buttonParams, jsonParams);
    buttonParams = mapWeightParams(buttonParams, jsonParams);
    buttonParams = mapCustomizedInfoParams(buttonParams, jsonParams);
    buttonParams = mapCartUrlParams(buttonParams, jsonParams);
    buttonParams = mapPayeePayerParams(buttonParams, jsonParams);
    buttonParams = mapShippingAddress(buttonParams, jsonParams);
    buttonParams = mapPaymentPreference(buttonParams, jsonParams);
    buttonParams = mapItemOptionSelectionParams(buttonParams, jsonParams);
    return buttonParams;
};

var mapCartParams = function mapCartParams(buttonParams, jsonParams) {
    if (jsonParams['invoice']) {
        buttonParams['invoice_number'] = jsonParams['invoice'];
    }
    if (jsonParams['no_note'] === '0') {
        buttonParams['prompt_note'] = true;
    } else {
        buttonParams['prompt_note'] = false;
    }
    if (jsonParams['address_override'] === '0') {
        buttonParams['address_override'] = false;
    } else if (jsonParams['address_override'] === '1') {
        buttonParams['address_override'] = true;
    }
    return buttonParams;
};

var mapCartAmounts = function mapCartAmounts(buttonParams, jsonParams) {
    if ((0, _validators.isValidAmount)(jsonParams['handling_cart'])) {
        buttonParams['total_handling_charges'] = moneyJson(jsonParams['currency_code'], jsonParams['handling_cart']);
    }
    return buttonParams;
};

var formatValue = function formatValue(amount, digits) {
    if (amount !== undefined) {
        return (+amount).toFixed(digits);
    }
    return amount;
};

var getCurrencyCode = function getCurrencyCode(currencyCode) {
    if (currencyCode === undefined) {
        return 'USD';
    }
    return currencyCode;
};

var moneyJson = function moneyJson(currencyCode, value) {
    return {
        currency_code: getCurrencyCode(currencyCode),
        value: formatValue(value, 2)
    };
};

var mapItemParams = function mapItemParams(buttonParams, jsonParams) {
    var itemParams = {
        'amount': 'price',
        'item_name': 'name',
        'item_number': 'sku',
        'tax': 'tax',
        'tax_rate': 'tax_rate',
        'currency_code': 'currency',
        'quantity': 'quantity',
        'handling': 'handling_cost'
    };
    var item = {};

    var validateAndMap = function validateAndMap(key, validator, digits) {
        if (validator(jsonParams[key])) {
            item[itemParams[key]] = digits ? formatValue(jsonParams[key], digits) : jsonParams[key];
        }
    };

    item[itemParams['handling']] = formatValue(0, 2); // default to 0 as per legacy behavior
    for (var key in itemParams) {
        if (itemParams.hasOwnProperty(key) && jsonParams[key]) {
            switch (key) {
                case 'amount':
                case 'tax':
                case 'handling':
                    validateAndMap(key, _validators.isNumber, 2);break;
                case 'tax_rate':
                    validateAndMap(key, _validators.isValidTaxRate, 3);break;
                case 'quantity':
                    validateAndMap(key, _validators.isValidQuantity);break;
                default:
                    item[itemParams[key]] = jsonParams[key];
            }
        }
    }
    item['currency'] = getCurrencyCode(jsonParams['currency_code']);

    var shippingAddressOptions = {
        '0': 'ALLOWED',
        '1': 'NEVER',
        '2': 'REQUIRED'
    };
    if (jsonParams['no_shipping']) {
        item['shipping_address_options'] = shippingAddressOptions[jsonParams['no_shipping']] || shippingAddressOptions[jsonParams['0']];
    }
    buttonParams.items = [];
    // if quantity is not passed make it 1 by default
    // if quantity is not a number then make it 1 by default
    if (item && (item.quantity === undefined || !Number.isInteger(+item.quantity) || item.quantity < 1)) {
        item.quantity = 1;
    }
    buttonParams.items[0] = item;
    return buttonParams;
};

var mapDiscountParams = function mapDiscountParams(buttonParams, jsonParams) {
    if (jsonParams['discount_num'] && Number.isInteger(+jsonParams['discount_num'])) {
        buttonParams.items[0].discount_options = {};
        buttonParams.items[0].discount_options.additional_eligible_items_count = jsonParams['discount_num'];
    }
    buttonParams = mapDiscountAmountParams(buttonParams, jsonParams);
    buttonParams = mapDiscountRateParams(buttonParams, jsonParams);
    return buttonParams;
};

var mapShippingParams = function mapShippingParams(buttonParams, jsonParams) {
    if (buttonParams.items === undefined) {
        buttonParams.items = [];
    }
    if ((0, _validators.isNumber)(jsonParams['shipping'])) {
        buttonParams.items[0].shipping_options = {};
        buttonParams.items[0].shipping_options['first_item_shipping_cost'] = moneyJson(jsonParams['currency_code'], jsonParams['shipping']);
        var additionalItemShippingCost = (0, _validators.isNumber)(jsonParams['shipping2']) ? jsonParams['shipping2'] : 0; // as per legacy behavior
        buttonParams.items[0].shipping_options['additional_item_shipping_cost'] = moneyJson(jsonParams['currency_code'], additionalItemShippingCost);
    }
    return buttonParams;
};

var mapWeightParams = function mapWeightParams(buttonParams, jsonParams) {
    if (jsonParams['weight_cart'] && (0, _validators.isWeightValid)(jsonParams['weight_cart'])) {
        buttonParams.total_weight = measurementJson(jsonParams['weight_cart'], jsonParams['weight_unit']);
    }
    if (jsonParams['weight'] && (0, _validators.isWeightValid)(jsonParams['weight'])) {
        buttonParams.items[0].weight = measurementJson(jsonParams['weight'], jsonParams['weight_unit']);
    }
    return buttonParams;
};

var measurementJson = function measurementJson(value, unit) {
    if (String(unit).toLowerCase() !== 'kgs') {
        unit = 'lbs';
    }
    return {
        unit: unit,
        value: value
    };
};

var replacePlus = function replacePlus(jsonParams) {
    var modifiedVal = void 0; // value after replacing + with ' '
    var modifiedParams = {};
    for (var key in jsonParams) {
        if (jsonParams.hasOwnProperty(key)) {
            if (jsonParams[key]) {
                modifiedVal = jsonParams[key].replace(/\+/g, ' ');
                if (jsonParams[key] !== modifiedVal) {
                    modifiedParams[key] = { orig: jsonParams[key], 'new': modifiedVal };
                    jsonParams[key] = modifiedVal;
                }
            }
        }
    }
    if (modifiedParams) {
        _logger.$logger.info('modifiedItemOptionsParams', modifiedParams);
    }
    return jsonParams;
};

var mapItemOptionSelectionParams = function mapItemOptionSelectionParams(buttonParams, jsonParams, retryAttempt) {
    var regexVar = {
        onX: { name: 'on', maxIndex: 29 },
        osX: { name: 'os', maxIndex: 29 },
        optionAmountSelection: { name: 'option_amount_selection', maxIndex: 29 },
        optionAmount: { name: 'option_amount', maxIndex: 29 },
        optionSelect: { name: 'option_select', maxIndex: 29 },
        optionItemNumber: { name: 'option_item_number', maxIndex: 29 }
    };

    var optionAmountIndex = jsonParams['option_amount_index'] || jsonParams['option_index'] || 0;
    var optionIndex = jsonParams['option_index'] || 0;
    // reset item_option_selections in case of second mapping attempt
    if (retryAttempt && buttonParams.items[0].item_option_selections) {
        buttonParams.items[0].item_option_selections = [];
    }
    for (var i = 0; i < regexVar.onX.maxIndex; i += 1) {
        var on = '' + regexVar.onX.name + i;
        var os = '' + regexVar.osX.name + i;

        var option = void 0;
        var optionBasedParams = void 0;
        if (jsonParams[on] || jsonParams[os]) {
            option = { name: jsonParams[on] };
            if (jsonParams[os]) {
                option['select'] = jsonParams[os];
                if (+optionAmountIndex === i) {
                    optionBasedParams = selectAmountFromOption(os, jsonParams, regexVar);
                    if (optionBasedParams.amount && (0, _validators.isValidAmount)(optionBasedParams.amount.value)) {
                        // Set the amount in the item's top level price.
                        buttonParams.items[0].price = formatValue(optionBasedParams.amount.value, 2);
                    }
                }
                if (+optionIndex === i) {
                    optionBasedParams = selectItemIdFromOption(os, jsonParams, regexVar);
                    if (optionBasedParams.item_number) {
                        buttonParams.items[0].sku = optionBasedParams.item_number;
                    }
                }
            } else {
                option['select'] = '-';
            }
        }

        // set the option only when option name is present or else ignore
        if (option && option.name) {
            buttonParams.items[0].item_option_selections = buttonParams.items[0].item_option_selections || [];
            buttonParams.items[0].item_option_selections.push(option);
        }
    }

    if (!buttonParams.items[0].price) {
        if (!retryAttempt) {
            mapItemOptionSelectionParams(buttonParams, replacePlus(jsonParams), true);
        }
    }

    return buttonParams;
};

var selectAmountFromOption = function selectAmountFromOption(os, jsonParams, regexVar) {
    var amount = void 0;

    for (var i = 0; i <= regexVar.optionAmount.maxIndex; i += 1) {
        var optionAmountSelection = '' + regexVar.optionAmountSelection.name + i;
        var optionSelect = '' + regexVar.optionSelect.name + i;
        var optionAmount = '' + regexVar.optionAmount.name + i;

        // The first match of many option_selectZ's matching always wins
        if (!jsonParams[optionAmountSelection]) {
            jsonParams[optionAmountSelection] = jsonParams[optionSelect];
        }

        if (jsonParams[os] === jsonParams[optionAmountSelection]) {
            if ((0, _validators.isValidAmount)(jsonParams[optionAmount])) {
                amount = {};
                amount.value = formatValue(jsonParams[optionAmount], 2);
                amount.currency = getCurrencyCode(jsonParams['currency_code']);
            }
            break; // First match wins even if option_amount not present!
        }
    }

    var params = {
        amount: amount
    };
    return params;
};

var selectItemIdFromOption = function selectItemIdFromOption(os, jsonParams, regexVar) {
    var itemId = void 0;

    for (var i = 0; i <= regexVar.optionSelect.maxIndex; i += 1) {
        var optionSelect = '' + regexVar.optionSelect.name + i;
        var optionItemNumber = '' + regexVar.optionItemNumber.name + i;

        // The first match of many option_selectZ's matching always wins
        if (jsonParams[os] === jsonParams[optionSelect]) {
            if (jsonParams[optionItemNumber]) {
                itemId = jsonParams[optionItemNumber];
            }
            break; // First match wins even if option_amount not present!
        }
    }
    var params = {
        item_number: itemId
    };
    return params;
};

var mapCustomizedInfoParams = function mapCustomizedInfoParams(buttonParams, jsonParams) {
    if (buttonParams.items === undefined) {
        buttonParams.items = [];
    }
    var customizedInfoParams = {
        'custom': 'custom',
        'cn': 'note_to_seller_label',
        'lc': 'locale_code',
        'bn': 'button_source',
        'cbt': 'return_url_label',
        'hosted_button_id': 'hosted_button_id',
        'mrb': 'mrb_code'
    };
    buttonParams.items[0].customized_info = {};
    for (var key in customizedInfoParams) {
        if (customizedInfoParams.hasOwnProperty(key) && jsonParams[key]) {
            buttonParams.items[0].customized_info[customizedInfoParams[key]] = jsonParams[key];
        }
    }
    var rmMap = {
        '0': 'GET',
        '1': 'GET',
        '2': 'POST'
    };
    if (jsonParams['rm'] === undefined) {
        buttonParams.items[0].customized_info['return_method'] = rmMap['0'];
    } else {
        buttonParams.items[0].customized_info['return_method'] = rmMap[jsonParams['rm']];
    }
    return buttonParams;
};

var mapCartUrlParams = function mapCartUrlParams(buttonParams, jsonParams) {
    var cartUrlParams = {
        'shopping_url': 'shopping_url',
        'image_url': 'image_url',
        'return': 'return_url',
        'cancel_return': 'cancel_url',
        'notify_url': 'notify_url'
    };
    buttonParams.urls = {};
    for (var key in cartUrlParams) {
        if (cartUrlParams.hasOwnProperty(key) && jsonParams[key]) {
            buttonParams.urls[cartUrlParams[key]] = jsonParams[key];
        }
    }
    return buttonParams;
};

var mapPayeePayerParams = function mapPayeePayerParams(buttonParams, jsonParams) {
    buttonParams = mapPayeeParams(buttonParams, jsonParams);
    buttonParams = mapPayerParams(buttonParams, jsonParams);
    return buttonParams;
};

var mapPayeeParams = function mapPayeeParams(buttonParams, jsonParams) {
    buttonParams.visitor_id = jsonParams['visitor_id'];
    buttonParams.payee = {};
    buttonParams.payee.email = jsonParams['merchant_email'];
    buttonParams.payee.business_name = jsonParams['business_name'];
    if (!buttonParams.payee.business_name) {
        buttonParams.payee.business_name = buttonParams.payee.email;
    }
    return buttonParams;
};

var mapPayerParams = function mapPayerParams(buttonParams, jsonParams) {
    var payerParams = {
        email: 'email',
        first_name: 'first_name',
        last_name: 'last_name'
    };
    for (var key in payerParams) {
        if (payerParams.hasOwnProperty(key) && jsonParams[key]) {
            if (!buttonParams.payer_info) {
                buttonParams.payer_info = {};
            }
            buttonParams.payer_info[payerParams[key]] = jsonParams[key];
        }
    }
    buttonParams = mapPhone(buttonParams, jsonParams);
    return buttonParams;
};

var mapPhone = function mapPhone(buttonParams, jsonParams) {
    var phoneParams = ['night_phone_a', 'night_phone_b', 'night_phone_c'];
    var phone = void 0;
    for (var i = 0; i < phoneParams.length; i += 1) {
        if (jsonParams[phoneParams[i]]) {
            phone = phone || '';
            phone += jsonParams[phoneParams[i]];
        }
    }
    if (phone) {
        buttonParams.payer_info = buttonParams.payer_info || {};
        buttonParams.payer_info.phone = phone;
    }
    return buttonParams;
};

var mapShippingAddress = function mapShippingAddress(buttonParams, jsonParams) {
    var addressParams = {
        address1: 'line1',
        address2: 'line2',
        city: 'city',
        country: 'country_code',
        zip: 'postal_code',
        state: 'state'
    };
    for (var key in addressParams) {
        if (addressParams.hasOwnProperty(key) && jsonParams[key]) {
            if (!buttonParams.shipping_address) {
                buttonParams.shipping_address = {};
            }
            buttonParams.shipping_address[addressParams[key]] = jsonParams[key];
        }
    }
    if (buttonParams.shipping_address) {
        if (!buttonParams.payer_info) {
            buttonParams.payer_info = {};
        }
        buttonParams.payer_info.billing_address = buttonParams.shipping_address;
    }
    return buttonParams;
};

var mapPaymentPreference = function mapPaymentPreference(buttonParams, jsonParams) {
    var paymentPreferenceOptions = {
        'sale': 'SALE',
        'auth': 'AUTH',
        'authorization': 'AUTH',
        'order': 'ORDER'
    };
    if (jsonParams['paymentaction']) {
        buttonParams.payment_preference = paymentPreferenceOptions[String(jsonParams['paymentaction']).toLowerCase()] || paymentPreferenceOptions['sale'];
    }
    return buttonParams;
};

var mapDiscountAmountParams = function mapDiscountAmountParams(buttonParams, jsonParams) {
    if ((0, _validators.isValidAmount)(jsonParams['discount_amount']) || (0, _validators.isValidAmount)(jsonParams['discount_amount2'])) {
        if (buttonParams.items[0].discount_options === undefined) {
            buttonParams.items[0].discount_options = {};
        }
        buttonParams.items[0].discount_options.discount_amount = [{}];
    }
    if ((0, _validators.isValidAmount)(jsonParams['discount_amount'])) {
        buttonParams.items[0].discount_options.discount_amount[0].first_item_discount_amount = moneyJson(jsonParams['currency_code'], jsonParams['discount_amount']);
    }
    if ((0, _validators.isValidAmount)(jsonParams['discount_amount2'])) {
        buttonParams.items[0].discount_options.discount_amount[0].additional_item_discount_amount = moneyJson(jsonParams['currency_code'], jsonParams['discount_amount2']);
    }
    return buttonParams;
};

var mapDiscountRateParams = function mapDiscountRateParams(buttonParams, jsonParams) {
    if ((0, _validators.isValidDiscountRate)(jsonParams['discount_rate']) || (0, _validators.isValidDiscountRate)(jsonParams['discount_rate2'])) {
        if (buttonParams.items[0].discount_options === undefined) {
            buttonParams.items[0].discount_options = {};
        }
        buttonParams.items[0].discount_options.discount_rate = [{}];
    }
    if ((0, _validators.isValidDiscountRate)(jsonParams['discount_rate'])) {
        buttonParams.items[0].discount_options.discount_rate[0].first_item_discount_rate = formatValue(jsonParams['discount_rate'], 3);
    }
    if ((0, _validators.isValidDiscountRate)(jsonParams['discount_rate2'])) {
        buttonParams.items[0].discount_options.discount_rate[0].additional_item_discount_rate = formatValue(jsonParams['discount_rate2'], 3);
    }
    return buttonParams;
};

var isItemPresentInList = function isItemPresentInList(buttonItem, itemList) {

    var buttonItemIndex = -1;
    _.forEach(itemList, function (item, index) {
        if (item.name === buttonItem.name && item.price === buttonItem.price && item.sku === buttonItem.sku) {

            var itemOptions = isItemOptionsEqual(item, buttonItem);
            var itemAmounts = isItemAmountsEqual(item, buttonItem);
            _logger.$logger.info('isItemOptionsEqual', { result: itemOptions });
            _logger.$logger.info('isItemAmountsEqual', { result: itemAmounts });
            if (itemOptions && itemAmounts) {
                buttonItemIndex = index;
            }
        }
    });

    return buttonItemIndex;
};

var isItemOptionsEqual = function isItemOptionsEqual(item, buttonItem) {
    if (item && item.item_option_selections && item.item_option_selections.length === 0) {
        delete item.item_option_selections;
    }
    if (!buttonItem.item_option_selections && !item.item_option_selections) {
        return true;
    } else if (!buttonItem.item_option_selections && item.item_option_selections) {
        return false;
    } else if (buttonItem.item_option_selections && !item.item_option_selections) {
        return false;
    } else if (buttonItem.item_option_selections && item.item_option_selections) {
        var buttonItemJson = JSON.stringify(buttonItem.item_option_selections);
        var itemJson = JSON.stringify(item.item_option_selections);
        // TODO: Do a JSON comparison instead of string comparison.
        // This still works because button item is always extracted in the same way
        if (buttonItemJson === itemJson) {
            return true;
        }
    }
    return false;
};

var isItemAmountsEqual = function isItemAmountsEqual(item, buttonItem) {

    if (!isShippingAmountEqual(item, buttonItem)) {
        _logger.$logger.info('isShippingAmountEqual', { result: false });
        return false;
    }
    if (!equalAmount(item.handling_cost, buttonItem.handling_cost)) {
        _logger.$logger.info('isHandlingCostEqual', { result: false });
        return false;
    }
    if (!equalAmount(item.insurance, buttonItem.insurance)) {
        _logger.$logger.info('isInsuranceEqual', { result: false });
        return false;
    }
    return true;
};

// checks if the first item shipping amount and additional item shipping amount is equal or not
var isShippingAmountEqual = function isShippingAmountEqual(item, buttonItem) {
    if (item.shipping_options && item.shipping_options.length === 0) {
        // TODO: delete this empty array in output mapper of the wrapper module
        delete item.shipping_options;
    }
    if (!buttonItem.shipping_options && !item.shipping_options) {
        return true;
    } else if (!buttonItem.shipping_options && item.shipping_options) {
        return false;
    } else if (buttonItem.shipping_options && !item.shipping_options) {
        return false;
    }
    var buttonShipping = buttonItem.shipping_options.first_item_shipping_cost;
    var itemShipping = item.shipping_options.first_item_shipping_cost;
    if (buttonShipping && itemShipping) {
        if (buttonShipping.value !== itemShipping.value) {
            return false;
        }
    }
    if (buttonShipping && !itemShipping || !buttonShipping && itemShipping) {
        return false;
    }

    buttonShipping = buttonItem.shipping_options.additional_item_shipping_cost;
    itemShipping = item.shipping_options.additional_item_shipping_cost;
    if (buttonShipping && itemShipping) {
        if (buttonShipping.value !== itemShipping.value) {
            return false;
        }
    }
    if (buttonShipping && !itemShipping || !buttonShipping && itemShipping) {
        return false;
    }
    return true;
};

var equalAmount = function equalAmount(amount1, amount2) {
    if (amount1 && !amount2) {
        return false;
    }
    if (!amount1 && amount2) {
        return false;
    }
    if (amount1 && amount2) {
        return amount1 === amount2;
    }
    return true;
};

var addItemAmounts = function addItemAmounts(itemsInCart) {
    if (!itemsInCart) {
        return;
    }
    var sum = 0;
    _.forEach(itemsInCart, function (item) {
        sum += item.removed ? 0 : item.price * item.quantity;
    });
    return sum;
};

_base.base64Encode;

_base.base64Decode;

_validators.isValidAmount;

_validators.isNumber;

_validators.isValidQuantity;

_validators.isValidTaxRate;

_validators.isValidDiscountRate;

_validators.isWeightValid;

_logger.$logger;

_customUtil.customUtil;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shopping-cart/cartUtil.js
// module id = ./pages/xo-shopping-cart/cartUtil.js
// module chunks = 1